import React from 'react'
import { Link } from 'react-router-dom'
import { ProjectTemplate, Template } from '../index'
import jsCheet from '../../media/jsCheet'
import PythonCheatSheet from '../../media/PythonCheatSheet.png'
import WebDev from '../../media/web-dev-blog.png';
import Java from '../../media/java.png';
import SoftwareEngeenering from '../../media/SoftwareEngeenering.png';
import UiUx from '../../media/UiUx';
export default function Blog(props) {
  return (
    <>
      <ProjectTemplate name='Blogs' mode={props.mode} isValue={props.isValue} >
        <Link to='/blog/javascript-cheetsheet'>
          <Template img={jsCheet} ></Template>
        </Link>
        <Link to='/blog/python-cheetsheet'>
          <Template img={PythonCheatSheet} ></Template>
        </Link>
        <Link to='/blog/java-cheatsheet'>
          <Template img={Java} ></Template>
        </Link>
        <Link to='/blog/html-css-cheatsheet'>
          <Template img={WebDev} ></Template>
        </Link>
        <Link to='/blog/software-cheatsheet'>
          <Template img={SoftwareEngeenering} ></Template>
        </Link>
        <Link to='/blog/ui-ux-cheatsheet'>
          <Template img={UiUx} ></Template>
        </Link>
      </ProjectTemplate>
    </>
  )
}
